import { SUPPORT_EMAIL_HREF, SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "@/constants/aptihealth";
import { Link2 } from "@/ui2/atoms/Link";

export function BillingSupportInfo() {
  return (
    <p className="body-xs" style={{ color: "var(--brand-gray-600) !important" }}>
      <b className="tw:block" style={{ color: "var(--brand-gray-600) !important" }}>
        Billing Support
      </b>
      For urgent support from the aptihealth team, please reach out to our front office at
      <Link2 className="tw:mx-0.5ch tw:whitespace-nowrap" href={SUPPORT_NUMBER_HREF}>
        {SUPPORT_NUMBER}
      </Link2>
      . For all other credit card or payment related questions, contact our billing team at
      <Link2 className="tw:mx-0.5ch" href={SUPPORT_EMAIL_HREF}>
        support@aptihealth.com
      </Link2>
      .
    </p>
  );
}
